import React, { FC } from 'react';
import i18n from 'i18n';
import styled from 'styled-components';

import { connect } from 'react-redux';

import { ModalProps } from '../types';
import { RowsContainer } from '../Common';
import Modal from '../../Modal/index';
import { ModalImageContainer, ModalImageContainerWithText } from '../../ImageContainer/ModalImageContainer';
import { ModalGrayText } from '../../Common';
import App from '../../../../models/app';

const UninstallContentContainer = styled(RowsContainer)`
  margin-top: 0px;
  display: flex;
  text-align: center;
  margin-bottom: 25px;
  flex-direction: column;
`;

const AppBannerDiv = styled.div`
  margin-bottom: 15px;
  align-self: center;
`;

const UninstallTilesText = styled.b`
  margin-top: 25px;
  margin-bottom: 25px;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.32px;

  color: #112530;
`;

const TileContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #E7E9EA;
  padding: 5px 0px;
`;

const mapStateToProps = (state: any) => {
  const {
    installedTiles
  } = state.registry;

  let tiles = [];
  if (installedTiles && Object.keys(installedTiles).length > 0) {
    tiles = Object.keys(installedTiles).map((tileId: any) => App.selectFromState(tileId, state));
  }

  return {
    tiles
  }
};

type ReduxProps = ReturnType<typeof mapStateToProps>;

interface UninstallModalProps extends ModalProps, ReduxProps {
}

const UninstallModal: FC<UninstallModalProps> = ({ app, tiles, deviceName, onCancel, onSuccess }) => {
  const ownTiles = tiles.filter((tile) => tile.parentApp.id === app.id)

  return (
    <Modal
      id={`UninstallModal`}
      title={i18n('component.UninstallModal.Title')({ appName: app.name })}
      onClose={onCancel}
      contentCenter={
        <UninstallContentContainer>
          <AppBannerDiv>
            <ModalImageContainer app={app} deviceName={deviceName} />
          </AppBannerDiv>
          <ModalGrayText>
            {i18n('component.UninstallModal.Content')()}
          </ModalGrayText>
          { ownTiles && ownTiles.length > 0 && (
              <React.Fragment>
                <UninstallTilesText>
                  {i18n('component.UninstallModal.TilesText')()}
                </UninstallTilesText>
                {ownTiles.map((tile: any) =>
                  <TileContainer key={tile.id} >
                    <ModalImageContainerWithText
                      app={tile}
                      text={tile.name}
                      subtext={tile.developer.name}
                      deviceName={deviceName}
                    />
                  </TileContainer>
                )}
              </React.Fragment>
          )}
        </UninstallContentContainer>
      }
      buttons={[
        {
          text: i18n('component.UninstallModal.CancelText')(),
          onClick: onCancel,
          testType: 'cancel-button',
          id: 'uninstall-button-cancel'
        },
        {
          text: i18n('component.UninstallModal.UninstallText')(),
          onClick: onSuccess,
          highlight: true,
          testType: 'uninstall-button',
          id: 'uninstall-button-ok'
        }
      ]}
    />
  );
};

export default connect(mapStateToProps, null)(UninstallModal);
